import { el, clear, createSheet, type SheetCtl } from "./components";
import type { Store } from "../store";

let sheet: SheetCtl | null = null;

export function openStats(store: Store): void {
  if (!sheet) sheet = createSheet("stats", "Statistik");
  render(store);
  sheet.open();
}

function pct(n: number, total: number): number {
  if (total === 0) return 0;
  return Math.round((n / total) * 100);
}

function render(store: Store): void {
  if (!sheet) return;
  clear(sheet.body);

  const g = store.globalStats();
  const session = store.state.session;
  const sessionHitRate = session.done > 0 ? pct(session.correct, session.done) : 0;

  const grid = el("div", { class: "stats-grid" }, [
    el("div", { class: "cell" }, [
      el("div", { class: "v", text: String(g.total) }),
      el("div", { class: "l", text: "Karten gesamt" }),
    ]),
    el("div", { class: "cell" }, [
      el("div", { class: "v", text: String(g.mastered) }),
      el("div", { class: "l", text: "Gefestigt" }),
    ]),
    el("div", { class: "cell" }, [
      el("div", { class: "v", text: `${sessionHitRate}%` }),
      el("div", { class: "l", text: "Trefferquote Session" }),
    ]),
    el("div", { class: "cell" }, [
      el("div", { class: "v", text: String(session.best) }),
      el("div", { class: "l", text: "Beste Serie" }),
    ]),
  ]);

  const masteryHead = el("h3", {
    text: "Fortschritt pro Kategorie",
    style: {
      fontSize: "16px",
      marginTop: "8px",
      fontFamily: "var(--font-ui)",
      textTransform: "uppercase",
      letterSpacing: "0.08em",
      color: "var(--muted)",
    },
  });

  const table = el("div", { class: "mastery-table" });
  for (const row of store.masteryByCategory()) {
    if (row.total === 0) continue;
    const p = pct(row.mastered, row.total);
    const r = el("div", { class: "mastery-row" }, [
      el("div", { class: "name", text: row.cat }),
      el("div", { class: "pct", text: `${row.mastered}/${row.total} · ${p}%` }),
      el("div", { class: "bar-mini" }, [
        el("span", { style: { width: `${p}%` } }),
      ]),
    ]);
    table.appendChild(r);
  }

  sheet.body.appendChild(grid);
  sheet.body.appendChild(masteryHead);
  sheet.body.appendChild(table);
}
